module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEdJREFUeNpiXLJkyREGBgZrBtzgCBMBBSBgw4QuEh0djaGKiYEIwILNBBh76dKlqIpgAiAFMDZJ1mEoQjcFpugoAYOOAgQYANuEEcZXHHJKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/more.png
// module id = Mqjo
// module chunks = 1